<template>
    <v-app id="dashboard">
        <v-navigation-drawer
                v-model="drawer.show"
                :clipped="drawer.clipped"
                :floating="drawer.floating"
                :mini-variant="drawer.mini"
                :permanent="drawer.type === 'permanent'"
                :temporary="drawer.type === 'temporary'"
                app
                overflow
        >
            <the-sidebar/>
        </v-navigation-drawer>

        <v-app-bar
                :clipped-left="drawer.clipped"
                app
                flat
                color="primary"
        >
            <the-header v-model="drawer.show"/>
        </v-app-bar>

        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>

<script>
    import TheHeader from "./TheHeader";
    import TheSidebar from "./TheSidebar";

    export default {
        name      : "AuthBase",
        components: {TheHeader, TheSidebar},
        data() {
            return {
                drawer: {
                    show    : null,
                    type    : 'default (no property)',
                    clipped : true,
                    floating: false,
                    mini    : false,
                }
            }
        },
        created() {
            this.$store.dispatch('card-types/fetch');
            this.$store.dispatch('clients/init');
        },
    }
</script>

<style scoped>

</style>
